/**
 * App Component
 *
 * This is the main component of the application.
 * It includes routing for different pages including the admin page.
 *
 * This component includes Google Analytics 4 tracking for:
 * - Page views
 * - Button clicks
 * - Time spent on page
 */

import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import ReactGA from 'react-ga4';
import './App.css';
import AdminPage from './components/AdminPage';
import VersionFooter from './components/VersionFooter';

function App() {
  const [sessionStartTime, setSessionStartTime] = useState(null);

  // Track page view and start session timer when component mounts
  useEffect(() => {
    // Only track if GA is initialized
    if (process.env.REACT_APP_GA_MEASUREMENT_ID &&
        process.env.REACT_APP_GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
      // Track page view
      ReactGA.send({
        hitType: 'pageview',
        page: window.location.pathname,
        title: 'WhatsApp Chat App Home'
      });

      // Start session timer
      setSessionStartTime(new Date());

      // Log user engagement
      ReactGA.event({
        category: 'User',
        action: 'Session Started',
        nonInteraction: true
      });
    }

    // Clean up function to track session duration when component unmounts
    return () => {
      if (sessionStartTime && process.env.REACT_APP_GA_MEASUREMENT_ID) {
        const sessionDuration = Math.round((new Date() - sessionStartTime) / 1000);
        ReactGA.event({
          category: 'User',
          action: 'Session Ended',
          label: 'Duration',
          value: sessionDuration
        });
      }
    };
  }, [sessionStartTime]);

  // Example function to track button clicks
  const handleExampleButtonClick = () => {
    ReactGA.event({
      category: 'User Interaction',
      action: 'Button Click',
      label: 'Example Button'
    });

    alert('Button clicked! This event was tracked in Google Analytics.');
  };

  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <h1>Gruper</h1>
          <p>Welcome to the Gruper WhatsApp Chat Application</p>
          <nav className="App-nav">
            <Link to="/" className="nav-link">Home</Link>
            <Link to="/admin" className="nav-link">Admin</Link>
          </nav>
        </header>

        <main className="App-main">
          <Routes>
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/" element={
              <div className="App-content">
                <h2>Hello</h2>
                <p>This is a placeholder for the future dashboard.</p>

                <div className="demo-section">
                  <h3>Google Analytics 4 Demo</h3>
                  <p>Click the button below to trigger a GA4 event:</p>
                  <button
                    className="demo-button"
                    onClick={handleExampleButtonClick}
                  >
                    Track Event in GA4
                  </button>
                  <p className="demo-note">
                    Note: Events will only be tracked if you've configured your GA4 Measurement ID
                    in the <code>.env</code> file.
                  </p>
                </div>
              </div>
            } />
          </Routes>
        </main>

        <footer className="App-footer">
          <p>&copy; {new Date().getFullYear()} Gruper</p>
        </footer>
        
        {/* Version footer with build information and session ID */}
        <VersionFooter />
      </div>
    </Router>
  );
}

export default App;
